import { render } from "./FavoriteCardComponent.vue?vue&type=template&id=0dba080f&scoped=true&ts=true"
import script from "./FavoriteCardComponent.vue?vue&type=script&lang=ts"
export * from "./FavoriteCardComponent.vue?vue&type=script&lang=ts"

import "./FavoriteCardComponent.vue?vue&type=style&index=0&id=0dba080f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dba080f"]])

export default __exports__